<script setup>
/**
 * A menu's items, the same in a dropdown (UiMenu) and in a menu at the pointer (UiPointMenu):
 * [{label, icon, action, danger, disabled, divider, to, header, hint, keep, testid, title, private}]
 * — `private`: its label names someone (masked in privacy mode, D-260).
 */
defineProps({ items: { type: Array, default: () => [] } })
const emit = defineEmits(['run', 'close'])
</script>

<template>
  <template v-for="(item, i) in items" :key="i">
    <div v-if="item.divider" class="my-1 border-t border-default"></div>
    <p v-else-if="item.header" v-private="!!item.private" class="px-3 pb-1 pt-2 text-2xs font-semibold uppercase tracking-wide text-faint">{{ item.label }}</p>
    <router-link v-else-if="item.to" :to="item.to" class="flex items-center gap-2 px-3 py-2 text-sm hover:bg-[var(--surface-3)]" role="menuitem" @click="emit('close')">
      <i v-if="item.icon" :class="['fa-solid fa-fw', item.icon, 'text-faint']" aria-hidden="true"></i>{{ item.label }}
    </router-link>
    <button
      v-else
      type="button"
      role="menuitem"
      :data-testid="item.testid || undefined"
      :title="item.title || undefined"
      :disabled="item.disabled"
      :class="['flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-[var(--surface-3)] disabled:opacity-40', item.danger ? 'text-red-600' : '']"
      @click="emit('run', item)"
    >
      <i v-if="item.icon" :class="['fa-solid fa-fw', item.icon, item.danger ? '' : 'text-faint']" aria-hidden="true"></i><span v-private="!!item.private" class="flex-1">{{ item.label }}</span><span v-if="item.hint" class="font-mono text-2xs text-faint">{{ item.hint }}</span>
    </button>
  </template>
</template>
